/**
 * Hardcoded dark theme colors for the Export Code dialog.
 * These colors are always dark regardless of the app's light/dark theme
 * to match the code editor aesthetic.
 */

export const exportCodeColors = {
  /** Code block background - #131211 */
  codeBackground: "#131211",

  /** Language tabs bar background - #1e1d1c */
  tabsBackground: "#1e1d1c",

  /** Copy button background - #282726 */
  buttonBackground: "#282726",

  /** Border color - rgba(255,255,255,0.1) */
  border: "rgba(255,255,255,0.1)",

  /** Button border color - rgba(255,255,255,0.06) */
  buttonBorder: "rgba(255,255,255,0.06)",

  /** Primary text color */
  text: "white",

  /** Secondary text color - rgba(255,255,255,0.6) */
  textSecondary: "rgba(255,255,255,0.6)",
} as const;
